import { AxiosInstance } from 'axios';

import { insertId } from '../insertId';

const toResponse = (response: any) => {
  if (!response.success) {
    throw new Error(
      `Response failed with code ${response.statusCode}: ${
        response.errorMessage
      }`
    );
  }

  return response.result;
};

export default (api: AxiosInstance, url: string) => async (link: string) => {
  const urlWithId = insertId(url, encodeURIComponent(link));
  const response = await api.get(urlWithId);
  return toResponse(response.data);
};



// WEBPACK FOOTER //
// ./src/services/api/link/getQR.ts